//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateLocales } from "@/typings/store/plugins/easyFirestore/locales";

const getters: GetterTree<StateLocales, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const locales = {
  firestorePath: "dev/v1/locales",
  firestoreRefType: "collection",
  moduleName: "locales",
  statePropName: "all",
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: "%convertTimestamp%", // default
      updated_at: "%convertTimestamp%", // default
    },
  },
  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default locales;
